"use strict";
/**
 * @module IconComponent
 *
 * Pass in the name of the icon/glyph/shape you need and if it's in the list below, it will return a span with those
 * classes, plus any modifier classes and text/text-filled elements if there are any any.
 *
 * NOTE: text will not be positioned in any way by default. Supply a modifier class to position it, if needed.
 *
 * Sample Usage
 * <IconComponent icon='RectangleLogo_large' />
 */
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.ICONS = {
    apMerchants_listContainerIcon_open: 'icon icon-small icon-action-arrow-down-half-small apMerchants_listContainerHeader-icon ',
    apMerchants_listContainerIcon_closed: 'icon icon-small icon-action-arrow-right-half-small apMerchants_listContainerHeader-icon ',
    RectangleLogo_large: 'rectangleLogo_large icon_table shadow ',
    RectangleLogo_small: 'rectangleLogo_small shadow ',
    CircleLogo_large: 'circleLogo_large shadow ',
    CircleLogo_small: 'circleLogo_small shadow ',
    BalancePpLogo_small: 'icon icon_table icon-small icon-pp-logo ppLogo ',
    BalancePpLogo_large: 'icon icon_table icon-medium icon-pp-logo-outline ',
    CheckMark_large: 'icon icon-positive-large icon-large ',
    DefaultBankLogo: 'icon icon-bank-half-solid ',
    DefaultCardLogo: 'icon icon-credit-card ',
    WarningIcon_small: 'icon icon-small icon-critical-small',
    WarningIcon_large: 'icon icon-large icon-critical-large',
    AttentionIcon_large: 'icon icon-large icon-attention-large',
    AttentionIcon_small: 'icon icon-small icon-attention-small',
    SuccessIcon_large: 'icon icon-large icon-circled-checkmark-large'
};
exports.IMAGES = {
    Success: 'https://www.paypalobjects.com/digitalassets/c/paypal-ui/illustrations/svg/success.svg'
};
function IconComponent(_a) {
    var _b = _a.icon, icon = _b === void 0 ? '' : _b, _c = _a.modifierClass, modifierClass = _c === void 0 ? '' : _c;
    return React.createElement("span", { className: exports.ICONS[icon] + ' ' + modifierClass });
}
exports.default = IconComponent;
function IllustrationComponent(_a) {
    var _b = _a.image, image = _b === void 0 ? '' : _b, _c = _a.modifierClass, modifierClass = _c === void 0 ? '' : _c;
    return React.createElement("img", { className: modifierClass, src: exports.IMAGES[image] });
}
exports.IllustrationComponent = IllustrationComponent;
